import type { DrawerProps } from '@mui/material'
import { Box, Drawer, styled } from '@mui/material'
import { forwardRef } from 'react'

const UnstyledStickyDrawer = forwardRef<HTMLDivElement, Omit<DrawerProps, 'variant'>>(({ children, ...props }, ref) => (
  <Drawer variant="permanent" {...props} ref={ref}>
    <Box className="sticky-container">{children}</Box>
  </Drawer>
))

UnstyledStickyDrawer.displayName = 'UnstyledStickyDrawer'

/**
 * open and close feature not compatible for now
 */
const StickyDrawer = styled(UnstyledStickyDrawer)(({ theme }) => ({
  flex: 'unset',
  '.MuiDrawer-paper': {
    boxSizing: 'border-box',
    position: 'static',
    display: 'block',
    overflowY: 'visible',
    width: 350,
  },
  '.sticky-container': {
    position: 'sticky',
    top: 0,
    left: 0,
    bottom: 0,
    overflowY: 'auto',
    height: 'auto',
    maxHeight: '100vh',
    padding: theme.spacing(1),
    scrollbarWidth: 'none',
  },
}))

export default StickyDrawer
